import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'
import { EPlatformType, IError } from '@unfoldrtech/portal-mic'
import {
  EReportColumnHeader,
  EParamChannelTypeGlobal,
  EReportingTimeWindow,
} from '@unfoldrtech/portal-mic/dist/src/models/core'

import { coreAPI } from '../services/coreAPI'
import { generateCorrelationId, getTimezone } from '../utils/helpers'
import {
  TDAProductsReportTableFilters,
  TPPRetailerId,
  TSPProductsReportTableFilters,
} from '../models/types'
import { IReportingProductsTableResponse } from '../models'

export default function useGetRetailerReportingProductsTableV3({
  retailerId,
  advertiserId,
  campaignId,
  adGroupId,
  channelType,
  productId,
  platformType,
  sortBy,
  timeWindow,
  startDate,
  endDate,
  sortOrder,
  tzZone,
  pageLimit,
  pageOffset,
  filterBy,
  filterOperation,
  filterValue,
  name,
  status,
  enabled = true,
  suspense = true,
}: {
  enabled?: boolean
  suspense?: boolean
} & (TSPProductsReportTableFilters | TDAProductsReportTableFilters) &
  TPPRetailerId): UseQueryResult<
  AxiosResponse<IReportingProductsTableResponse>,
  AxiosError<IError>
> {
  const queryKeyName = `getRetailerReportingProductsTable_${channelType}_${retailerId}_${advertiserId}`

  return useQuery(
    [queryKeyName, { start: startDate, end: endDate, channelType }],
    () => {
      return coreAPI.v2RetailerReporting().getRetailerProductsReportTable(
        retailerId,
        generateCorrelationId(),
        advertiserId,
        campaignId,
        adGroupId,
        channelType as EParamChannelTypeGlobal,
        productId,
        platformType as unknown as EPlatformType,
        sortBy as EReportColumnHeader,
        sortOrder,
        timeWindow as EReportingTimeWindow,
        startDate,
        endDate,
        tzZone || getTimezone(),
        pageLimit,
        pageOffset,
        filterBy,
        filterOperation,
        filterValue,
        name,
        // @ts-expect-error: fix in PORT-2535
        status
      )
    },
    { suspense, enabled }
  )
}
